import { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import AppLinkButton from 'components/app/AppLinkButton';
import MainNoticeItemWithImage from './MainNoticeItemWithImage';
import { useMainAnnouncementStore } from 'store/useMainAnnouncementStore';
import { announcementAllUrl } from 'helper/helper';

import './MainNoticeContainer.scss';

export const MainNoticeContainer = () => {
    const { fetchMainAnnouncement } = useMainAnnouncementStore();
    const mainAnnouncementList = useMainAnnouncementStore(
        (state) => state.mainAnnouncementList
    );

    useEffect(() => {
        fetchMainAnnouncement();
    }, []);

    return (
        <Container className='notice-container' fluid>
            <h1>NOTÍCIAS</h1>

            <Row className='notice-container-items'>
                {mainAnnouncementList.map((list, index) => {
                    return (
                        <Col key={index} className='notice-container-item'>
                            <MainNoticeItemWithImage
                                type={list.n_type}
                                item={list}
                            />
                        </Col>
                    );
                })}
            </Row>

            <Row className='notice-container-more-button'>
                <AppLinkButton buttonText='MAIS' link={announcementAllUrl} />
            </Row>
        </Container>
    );
};
